import { createReducer } from "@reduxjs/toolkit";
import { GetOrganizationList } from "./organizationAction";

export interface IOrganizationState {
  organizationList: any[];
  dataCount: number;
  isLoading: boolean;
}

const initialState: IOrganizationState = {
  organizationList: [],
  dataCount: 0,
  isLoading: false,
};

export const organizationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(GetOrganizationList.pending, (state) => {
      state = { ...state, isLoading: true };
      return state;
    })
    .addCase(GetOrganizationList.fulfilled, (state, action) => {
      state = {
        ...state,
        organizationList: action.payload?.data ?? [],
        dataCount: action.payload?.dataCount ?? 0,
        isLoading: false,
      };
      return state;
    })
    .addCase(GetOrganizationList.rejected, (state) => {
      state = { ...state, isLoading: false };
      return state;
    });
});
